$(document).ready(function () {
  var productId = 7441953587253;
  var $priceContainer = $('.product-price-container');
  var variants = [];
  var variantsJsonEl = document.getElementById('product-variants-json');
  var variantChangeTimer = null;

  if (variantsJsonEl) {
    try {
      variants = JSON.parse(variantsJsonEl.textContent || '[]');
    } catch (e) {
      console.error('Variants JSON parse error', e);
    }
  }

  if (productId === 7441953587253) {
    $('quantity-selector .quantity__input').val(2);
  }

  function getPriceWrapper() {
    return $('.product-price-container .price').first();
  }

  function getStickyPriceWrappers() {
    return $('[data-sticky-price]').find('.price');
  }

  function parseMoney(text) {
    if (!text) return 0;
    return parseFloat(String(text).replace(/[^0-9.]/g, '')) || 0;
  }

  function formatMoney(amount) {
    return '$' + Math.ceil(amount);
  }

  function markUpdating() {
    $priceContainer.removeClass('is-ready').addClass('is-updating');
  }

  function markReady() {
    $priceContainer.removeClass('is-updating').addClass('is-ready');
  }

  function forceShowPrice() {
    var $price = $('.product-price-container__discount_box .price').first();
    if (!$price.length) return;

    $price[0].style.removeProperty('display');
    $price[0].style.removeProperty('visibility');
    $price[0].style.removeProperty('opacity');
    $price[0].style.setProperty('display', 'flex', 'important');
  }

  function forceShowStickyPrice() {
    getStickyPriceWrappers().each(function () {
      this.style.removeProperty('display');
      this.style.removeProperty('visibility');
      this.style.removeProperty('opacity');
      this.style.setProperty('display', 'flex', 'important');
    });
  }

  function ensurePriceElements() {
    var $priceWrapper = getPriceWrapper();
    if (!$priceWrapper.length) return false;

    if (!$priceWrapper.find('.price__compare').length) {
      $priceWrapper.prepend('<del class="price__compare hidden"><span class="amount"></span></del>');
    }

    if (!$priceWrapper.find('.price__current').length) {
      var $existingIns = $priceWrapper.find('ins').first();

      if ($existingIns.length) {
        $existingIns.addClass('price__current');
      } else {
        $priceWrapper.prepend('<ins class="price__current"><span class="amount"></span></ins>');
      }
    }

    if (!$priceWrapper.find('.price__badge').length) {
      $priceWrapper.append('<span class="price__badge hidden"></span>');
    }

    return true;
  }

  function ensureStickyPriceElements() {
    var $wrappers = getStickyPriceWrappers();
    if (!$wrappers.length) return false;

    $wrappers.each(function () {
      var $priceWrapper = $(this);

      if (!$priceWrapper.find('.price__compare').length) {
        $priceWrapper.prepend('<del class="price__compare hidden"><span class="amount"></span></del>');
      }

      if (!$priceWrapper.find('.price__current').length) {
        var $existingIns = $priceWrapper.find('ins').first();

        if ($existingIns.length) {
          $existingIns.addClass('price__current');
        } else {
          $priceWrapper.prepend('<ins class="price__current"><span class="amount"></span></ins>');
        }
      }

      if (!$priceWrapper.find('.price__badge').length) {
        $priceWrapper.append('<span class="price__badge hidden"></span>');
      }
    });

    return true;
  }

  function getCurrentVariantId() {
    var value = $('form[action*="/cart/add"] input[name="id"]').val();
    return value ? Number(value) : null;
  }

  function findCurrentVariant() {
    var currentVariantId = getCurrentVariantId();
    if (!currentVariantId || !variants.length) return null;

    return variants.find(function (variant) {
      return Number(variant.id) === currentVariantId;
    }) || null;
  }

  function setBasePriceFromVariant() {
    var variant = findCurrentVariant();
    if (!variant) return 0;

    var basePrice = (variant.price || 0) / 100;

    if (basePrice > 0) {
      $priceContainer.attr('data-base-price', basePrice);
      $priceContainer.attr('data-variant-id', variant.id);
    }

    return basePrice;
  }

  function getBasePrice() {
    return parseFloat($priceContainer.attr('data-base-price')) || 0;
  }

  function getSelectedDiscountPercent() {
    var $activeBox = $('.discount-inner.active');
    if (!$activeBox.length) return 0;

    return parseFloat($activeBox.attr('data-discount-percent')) || 0;
  }

  function updateMainPrice(basePrice, discountPercent) {
    var ready = ensurePriceElements();
    if (!ready) return false;

    var $priceWrapper = getPriceWrapper();
    if (!$priceWrapper.length) return false;

    var finalPrice = basePrice * (1 - discountPercent / 100);

    var $compare = $priceWrapper.find('.price__compare');
    var $compareAmount = $compare.find('.amount');
    var $current = $priceWrapper.find('.price__current');
    var $currentAmount = $current.find('.amount');
    var $badge = $priceWrapper.find('.price__badge');

    $currentAmount.text(formatMoney(finalPrice));

    if (discountPercent > 0) {
      $compareAmount.text(formatMoney(basePrice));
      $compare.removeClass('hidden');

      $badge.text('Save ' + Math.round(discountPercent) + '%');
      $badge.removeClass('hidden');
    } else {
      $compare.addClass('hidden');
      $badge.addClass('hidden');
    }

    return true;
  }

  function updateStickyPrice(basePrice, discountPercent) {
    var ready = ensureStickyPriceElements();
    if (!ready) return false;

    var finalPrice = basePrice * (1 - discountPercent / 100);

    getStickyPriceWrappers().each(function () {
      var $priceWrapper = $(this);

      var $compare = $priceWrapper.find('.price__compare');
      var $compareAmount = $compare.find('.amount');
      var $current = $priceWrapper.find('.price__current');
      var $currentAmount = $current.find('.amount');
      var $badge = $priceWrapper.find('.price__badge');

      $currentAmount.text(formatMoney(finalPrice));

      if (discountPercent > 0) {
        $compareAmount.text(formatMoney(basePrice));
        $compare.removeClass('hidden');

        $badge.text('Save ' + Math.round(discountPercent) + '%');
        $badge.removeClass('hidden');
      } else {
        $compare.addClass('hidden');
        $badge.addClass('hidden');
      }
    });

    return true;
  }

  function updateDisplayedPrice() {
    var basePrice = getBasePrice();
    var discountPercent = getSelectedDiscountPercent();

    if (!basePrice) return false;

    updateMainPrice(basePrice, discountPercent);
    updateStickyPrice(basePrice, discountPercent);

    return true;
  }

  function getSelectedColor() {
    var $colorInputs = $('input[name="Color"]');
    if (!$colorInputs.length) return null;
    return $colorInputs.filter(':checked').val() || null;
  }

  function updateImage() {
    var $colorInputs = $('input[name="Color"]');

    if (!$colorInputs.length) return;

    var selectedValue = getSelectedColor();

    $('.terracotta_image, .slate_image').hide();

    if (selectedValue === 'Terracotta') {
      $('.terracotta_image').show();
    } else if (selectedValue === 'Slate') {
      $('.slate_image').show();
    }
  }

  function refreshVariantPrice() {
    clearTimeout(variantChangeTimer);

    markUpdating();

    variantChangeTimer = setTimeout(function () {
      setBasePriceFromVariant();
      updateDisplayedPrice();
      forceShowPrice();
      forceShowStickyPrice();
      markReady();
    }, 250);
  }

  ensurePriceElements();
  ensureStickyPriceElements();
  setBasePriceFromVariant();
  updateImage();
  updateDisplayedPrice();
  forceShowPrice();
  forceShowStickyPrice();
  markReady();

  $(document).on('change', 'input[name="Color"], input[type="radio"], select', function () {
    updateImage();
    refreshVariantPrice();
  });

  $(document).on('click', '.discount-inner', function () {
    $('.discount-inner').removeClass('active');
    $(this).addClass('active');

    var qty = $(this).attr('value');
    $('quantity-selector .quantity__input').val(qty);
    $('#prdcurrentValue').val(qty);

    markUpdating();

    setTimeout(function () {
      updateDisplayedPrice();
      forceShowPrice();
      forceShowStickyPrice();
      markReady();
    }, 20);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    var el = document.querySelector('.discount-inner[value="2"]');
    if (el) {
      el.click();
    }
  }, 4000);
});